import React from 'react';
import { UserIcon, UsersIcon, BuildingIcon, CheckIcon, ArrowRightIcon, ShieldCheckIcon, ClockIcon } from 'lucide-react';
export function Pricing() {
  const tiers = [{
    icon: UserIcon,
    name: 'Individual Leader Pass',
    price: 'USD 8,500',
    priceDetail: 'per person',
    color: 'from-cyan-500 to-blue-500',
    savings: null,
    features: ['3 nights at Hard Rock Hotel Cancun (single occupancy)', 'Full 48-hour curriculum & labs', 'All breakfasts, lunches, and two curated dinners', '1 x 60-minute post-bootcamp implementation clinic', 'Access to cohort alumni network', 'Digital resources and templates'],
    cta: 'Apply as an Individual Leader',
    highlight: false
  }, {
    icon: UsersIcon,
    name: 'Leadership Team Pod',
    price: 'USD 28,000',
    priceDetail: '4 leaders / USD 39,000 for 6 leaders',
    color: 'from-purple-500 to-pink-500',
    savings: 'Save USD 6,000 vs individual',
    features: ['Everything in Individual Pass', 'Dedicated team war room', 'Private session with senior strategy professor on your company', 'Customized AI roadmap canvas', 'Team alignment exercises and shared deliverables', 'Priority scheduling for post-bootcamp support'],
    cta: 'Apply as a Leadership Team',
    highlight: true
  }, {
    icon: BuildingIcon,
    name: 'Corporate Cohort',
    price: 'USD 160,000–220,000',
    priceDetail: 'Private track, up to ~20 seats',
    color: 'from-orange-500 to-red-500',
    savings: 'Best value for scale',
    features: ['Private track for your company inside the cohort', 'Pre-bootcamp diagnostic interviews', 'Co-branded assets for internal rollout', '2–3 post-bootcamp virtual sessions', 'Executive briefing deck for board/leadership', 'Dedicated account manager'],
    cta: 'Book a Corporate Discovery Call',
    highlight: false
  }];
  return <section className="py-24" data-id="element-313">
      <div className="max-w-7xl mx-auto px-6" data-id="element-314">
        {/* Urgency banner */}
        <div className="mb-12 text-center" data-id="element-315">
          <div className="inline-flex items-center gap-2 px-6 py-3 bg-orange-500/20 border border-orange-500/40 rounded-full mb-6" data-id="element-316">
            <ClockIcon className="w-5 h-5 text-orange-400" data-id="element-317" />
            <span className="text-lg font-semibold text-orange-300" data-id="element-318">
              Next Cohort: March 15-18, 2024 • 8 Spots Remaining
            </span>
          </div>
        </div>

        <div className="text-center mb-16" data-id="element-319">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-320">
            Investment & Packages
          </h2>
          <p className="text-xl text-slate-400 max-w-3xl mx-auto mb-6" data-id="element-321">
            Choose the format that fits your goals—individual, team, or
            company-wide transformation
          </p>
          <p className="text-sm text-slate-500" data-id="element-322">
            Compare: Similar executive programs at Stanford or Wharton cost
            $15,000-$25,000 for 5 days with no AI focus
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-12" data-id="element-323">
          {tiers.map((tier, index) => {
          const Icon = tier.icon;
          return <div key={index} className={`relative bg-slate-900/50 border rounded-2xl p-8 ${tier.highlight ? 'border-purple-500 shadow-2xl shadow-purple-500/20 scale-105' : 'border-slate-800'}`} data-id="element-324">
                {tier.highlight && <div className="absolute -top-4 left-1/2 transform -translate-x-1/2" data-id="element-325">
                    <span className="px-4 py-1 bg-gradient-to-r from-purple-500 to-pink-500 text-white text-sm font-semibold rounded-full" data-id="element-326">
                      Most Popular • 70% Choose This
                    </span>
                  </div>}

                <div className={`w-14 h-14 bg-gradient-to-br ${tier.color} rounded-xl flex items-center justify-center mb-6`} data-id="element-327">
                  <Icon className="w-7 h-7 text-white" data-id="element-328" />
                </div>

                <h3 className="text-2xl font-bold text-white mb-2" data-id="element-329">
                  {tier.name}
                </h3>

                <div className="mb-6" data-id="element-330">
                  <div className="text-4xl font-bold text-white mb-1" data-id="element-331">
                    {tier.price}
                  </div>
                  <div className="text-sm text-slate-400 mb-2" data-id="element-332">
                    {tier.priceDetail}
                  </div>
                  {tier.savings && <div className="text-sm text-green-400 font-semibold" data-id="element-333">
                      {tier.savings}
                    </div>}
                </div>

                <div className="space-y-3 mb-8" data-id="element-334">
                  {tier.features.map((feature, i) => <div key={i} className="flex items-start gap-3" data-id="element-335">
                      <CheckIcon className="w-5 h-5 text-cyan-400 flex-shrink-0 mt-0.5" data-id="element-336" />
                      <p className="text-slate-300 text-sm" data-id="element-337">{feature}</p>
                    </div>)}
                </div>

                <button className={`w-full py-3 rounded-lg font-semibold transition-all duration-300 flex items-center justify-center gap-2 ${tier.highlight ? 'bg-gradient-to-r from-purple-500 to-pink-500 text-white hover:shadow-xl hover:shadow-purple-500/50' : 'bg-slate-800 text-white hover:bg-slate-700'}`} data-id="element-338">
                  {tier.cta}
                  <ArrowRightIcon className="w-4 h-4" data-id="element-339" />
                </button>
              </div>;
        })}
        </div>

        {/* Guarantee */}
        <div className="bg-gradient-to-br from-green-900/30 to-emerald-900/30 border border-green-500/30 rounded-2xl p-8 mb-8 text-center" data-id="element-340">
          <div className="flex items-center justify-center gap-3 mb-4" data-id="element-341">
            <ShieldCheckIcon className="w-8 h-8 text-green-400" data-id="element-342" />
            <h3 className="text-2xl font-bold text-white" data-id="element-343">
              60-Day Money-Back Guarantee
            </h3>
          </div>
          <p className="text-slate-300 max-w-3xl mx-auto" data-id="element-344">
            If you don't leave with a concrete 90-day AI action plan, working
            prototypes, and the confidence to lead your company's AI
            transformation, we'll refund 100% of your investment. No questions
            asked.
          </p>
        </div>

        {/* Important notes */}
        <div className="bg-slate-900/50 border border-slate-800 rounded-xl p-8" data-id="element-345">
          <h4 className="text-lg font-semibold text-white mb-4" data-id="element-346">
            Important Details
          </h4>
          <div className="grid md:grid-cols-3 gap-6 text-sm text-slate-400" data-id="element-347">
            <div className="flex items-start gap-2" data-id="element-348">
              <div className="w-1.5 h-1.5 bg-cyan-400 rounded-full mt-2 flex-shrink-0" data-id="element-349"></div>
              <p data-id="element-350">
                Flights not included. Participants arrange their own travel to
                Cancun.
              </p>
            </div>
            <div className="flex items-start gap-2" data-id="element-351">
              <div className="w-1.5 h-1.5 bg-purple-400 rounded-full mt-2 flex-shrink-0" data-id="element-352"></div>
              <p data-id="element-353">
                Limited to one cohort per month. Maximum 24 participants per
                cohort.
              </p>
            </div>
            <div className="flex items-start gap-2" data-id="element-354">
              <div className="w-1.5 h-1.5 bg-green-400 rounded-full mt-2 flex-shrink-0" data-id="element-355"></div>
              <p data-id="element-356">
                Payment plans available for teams and corporate cohorts.
                Corporate POs accepted.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}